import { ControlConfig } from '../controlConfig';
import AddNewImage from './AddNewImage';
import ControlImageEngine from './ControlImageEngine';
import ControlImageEntry from './ControlImageEntry';
import ControlImagePlaceholder from './ControlImagePlaceholder';
import getLatestSchema from './schema';
import getYupSchemaForImageEngine from './getYupSchemaForImageEngine';
import translator from './translator';

export default {
  getDefaultValue: () => ({}),
  getLatestSchema,
  Engine: ControlImageEngine,
  Entry: ControlImageEntry,
  Add: AddNewImage,
  yupSchemaEngine: getYupSchemaForImageEngine,
  yupSchemaEntry: () => ({}),
  translator,
  Placeholder: ControlImagePlaceholder,
  hasAttachment: true,
  previewCardHeight: '120px'
} as ControlConfig;
